import { render, staticRenderFns } from "./NotiListForStoreView.vue?vue&type=template&id=222c2d19"
import script from "./NotiListForStoreView.vue?vue&type=script&lang=js"
export * from "./NotiListForStoreView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports